import { useId, type ComponentProps, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

function Frame({
  title,
  description,
  actions,
  className,
  children,
  ...props
}: Omit<ComponentProps<'section'>, 'title'> & {
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
}) {
  const headingId = useId()
  return (
    <section
      data-slot="frame"
      aria-labelledby={headingId}
      className={cn('bg-muted/50 border-border flex min-w-0 flex-col gap-1.5 rounded-xl border p-1.5', className)}
      {...props}
    >
      <header className="flex min-h-5 items-center justify-between gap-2 pl-2.5">
        <div className="flex min-w-0 flex-col">
          <h3 id={headingId} className="text-foreground/75 text-[11px] font-medium">{title}</h3>
          {description ? <p className="text-muted-foreground text-[11px]">{description}</p> : null}
        </div>
        {actions}
      </header>
      {children}
    </section>
  )
}

function FrameCard({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="frame-card"
      className={cn('bg-card border-border min-w-0 rounded-lg border shadow-xs', className)}
      {...props}
    />
  )
}

function FrameConnector({ className, ...props }: ComponentProps<'p'>) {
  return (
    <p
      data-slot="frame-connector"
      className={cn('text-muted-foreground px-4 text-xs font-semibold', className)}
      {...props}
    />
  )
}

export { Frame, FrameCard, FrameConnector }
